import React from "react";

function FirstSection() {
  return (
    <section>
      <div className=" p-2">
        <div className="row ">
          <div className="col-md-7">
            <div className="col-md-12 d-flex justify-content-center justify-content-md-start p-2">
              <img
                src={window.origin + "/WebSide/assets/images/readmap.png"}
                alt="nikotan | نیکوتن"
                style={{ width: "280px" }}
              />
            </div>
            <div className="p-1 mt-3 roadmap-content">
              <p style={{}}>
                سامانه نیکوتن پس از بررسی نیاز بازار از سال 1398 فعالیت خود را
                در مرکز شهرستان نیشابور آغاز کرد
                <br />
                این سامانه سعی دارد دهه آتی به جامع ترین سامانه رزرو آنلاین
                ورزشی کشور تبدیل شود که مورد
                <br />
                اعتماد ذینفعان، ورزشکاران، مربیان، باشگاه ها و مجموعه هاي ورزشی
                در زمینه ارائه خدمات نوبت دهی
                <br />
                و برنامه ریزي ورزشی می باشد. نیکوتن با آسان سازي فرآیندهاي موجود
                و ارائه خدمات نوین تلاش
                <br />
                خواهد نمود جایگاه خود را در قلمرو فعالیت هاي متنوع خود حفظ
                نمایند.
              </p>
            </div>
            <div className="d-flex justify-content-md-end justify-content-center mt-5">
              <button className="btn btn-danger">دانلود اپلیکیشن</button>
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <img
                src={window.origin + "/WebSide/assets/images/mockup.png"}
                alt="nikotan | نیکوتن"
                width={"100%"}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FirstSection;
